var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.hideNav && _vm.isAuthenticated)?_c('app-navigation',{staticClass:"hidden-print"}):_vm._e(),_c('v-main',[_c('v-scroll-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }